// @ts-check
import { z } from 'zod';

import Permission from '@/store/modules/models/global/Permission';
import { UserSummary } from '@/store/modules/users/models';
import Timestamp from '@/store/modules/models/global/Timestamp';

export const BulkSend = z.object({
  fingerprint: z.string(),
  name: z.string(),
  message: z.string().nullable(),
  parallel_signing: z.boolean().nullable(),
  steps_progress: z
    .object({ hash: z.number(), index: z.number(), updated_at: z.number() })
    .nullable(),
  envelope_expires_after: z.number().nullable(),
  envelope_reminder_interval: z.number().nullable(),
  imported_filename: z.string().nullable(),
  import_status: z.enum([
    'requires-templates',
    'requires-roles',
    'requires-csv',
    'queued',
    'processing',
    'failed',
    'complete',
  ]),
  imported_rows_count: z.number().nullable(),
  import_valid: z.boolean(),
  sent_at: z.number().nullable(),
  status: z.enum(['draft', 'processing', 'failed', 'complete']),
  thumbnail: z.string().nullable(),
  retries_attempted: z.number()
    .int()
    .nonnegative()
    .lte(3)
    .nullable(),
  failed_at: z.number().nullable(),
  failed_reason: z.string().nullable(),
  failed_message: z.string().nullable(),
  completed_at: z.number().nullable(),
  created_at: Timestamp,
  updated_at: Timestamp,
  everyone_permission: Permission.nullable(),
  created_by: UserSummary,
  sent_by: UserSummary.nullable(),
});

export const ListBulkSend = BulkSend.pick({
  fingerprint: true,
  name: true,
  created_at: true,
  status: true,
  thumbnail: true,
  retries_attempted: true,
  failed_message: true,
});

/** @typedef {z.infer<typeof BulkSend>} TBulkSend */
